import { renderCallback, renderSurvey } from './survey';

document.addEventListener('DOMContentLoaded', renderSurvey, false);

window.hjRenderCallback = renderCallback;
